import React from "react";
import { Main } from "../Styles/Global.Styled";
import PageHeader from "../Components/PageBanner/PageHeader";
import SectionType1 from "../Components/Sections/SectionType1";
import aboutUsPage_1 from "../assets/Images/aboutUsPage_1.jpg";
import aboutUsPage_2 from "../assets/Images/aboutUsPage_2.jpg";
import aboutUsPage_3 from "../assets/Images/aboutUsPage_3.jpg";
import aboutUsPage_4 from "../assets/Images/aboutUsPage_4.jpg";
import yourPartnerBG from "../assets/Images/yourPartnerBG.jpeg";
import ourHistoryBG from "../assets/Images/ourHistoryBG.jpg";
import Testimonials from "../Components/ClientsReviews/Testimonials";
import SectionType2 from "../Components/Sections/SectionType2";

const aboutUsPageContent = [
  {
    id: "who-we-are",
    header: "About Fresh Flowers Supply",
    paragraph:
      "Welcome to Dutch Florist Supply, your trusted partner in floral excellence for over three decades. Nestled in the heart of Naaldwijk, the Netherlands, our journey in the wholesale floristry business began over 30 years ago with a passion for delivering the freshest and most exquisite blooms to our clients.",
    img: aboutUsPage_1,
    flexD: "row",
  },
  {
    header: "Dutch Excellence, Global Reach",
    paragraph:
      "Welcome to Dutch Florist Supply, your trusted partner in floral excellence for over three decades. Nestled in the heart of Naaldwijk, the Netherlands, our journey in the wholesale floristry business began over 30 years ago with a passion for delivering the freshest and most exquisite blooms to our clients.",
    img: aboutUsPage_2,
    flexD: "row-reverse",
  },
  {
    id: "our-values",
    header: "Unparalleled Floral Expertise",
    paragraph: `At Dutch Florist Supply, we are more than just florists; we are floral enthusiasts dedicated to bringing the beauty of nature to your doorstep. Our team of seasoned floral experts meticulously curates a diverse selection of flowers, foliage, and botanical accessories, ensuring that each stem we offer is a masterpiece of nature's artistry.`,
    img: aboutUsPage_3,
    flexD: "row",
  },
  {
    header: "Sustainable Practices",
    paragraph:
      "As stewards of the environment, we are committed to sustainable and eco-friendly practices. From responsible sourcing to eco-conscious packaging, we prioritize the well-being of our planet. We believe that every bloom should not only bring joy to those who receive it but also contribute to a healthier and more sustainable world.",
    img: aboutUsPage_4,
    flexD: "row-reverse",
  },
];
const partnerPromoContent = {
  header: "Your Floral Partner",
  paragraph: (
    <>
      Whether you are a florist, event planner, or retailer, Dutch Florist
      Supply is your dedicated floral partner. Our commitment to excellence
      extends beyond our products to personalized customer service that exceeds
      expectations. We strive to build lasting relationships with our clients,
      understanding their unique needs and delivering floral solutions that
      captivate and inspire.
      <br />
      <br />
      Thank you for considering Dutch Florist Supply as your wholesale florist.
      Join us in celebrating the timeless beauty of flowers and let our blooms
      be the language through which you express your emotions, creativity, and
      style.
    </>
  ),
  img: yourPartnerBG,
  color: "white",
  fontSize: "L",
};
const ourHistoryContent = {
  id: "our-history",
  header: "Our History",
  subHeader: "A little story about",
  paragraph: (
    <>
      Established in 1991, we take pride in our rich heritage as a family-owned
      wholesale florist company. From our humble beginnings, we have grown to
      become a cornerstone in the floral industry, supplying our exceptional
      products to clients spanning the entire Middle East. Our commitment to
      quality, reliability, and unmatched service has been the driving force
      behind our success.
    </>
  ),
  img: ourHistoryBG,
};

const AboutUs = () => {
  return (
    <Main>
      <PageHeader header={"About us"} />
      <SectionType1 content={aboutUsPageContent[0]} />
      <SectionType1 content={aboutUsPageContent[1]} />
      <SectionType2 content={ourHistoryContent} />
      <SectionType1 content={aboutUsPageContent[2]} />
      <SectionType1 content={aboutUsPageContent[3]} />
      <Testimonials />
      <SectionType2 content={partnerPromoContent} />
    </Main>
  );
};

export default AboutUs;
